import styled from '@emotion/styled';

const Circle = styled.circle`
  fill: transparent;
  stroke-linecap: round;
  transform-origin: 50% 50%;
`;
export const ProgressRing = styled(Circle)`
  stroke: #1d1d1d;
  transition: stroke-dashoffset 0.35s;
`;
export const ProgressRingPlaceholder = styled(Circle)`
  stroke: rgba(29, 29, 29, 0.3);
`;

export const Text = styled.text`
  font-family: Helvetica Neue;
  font-weight: 700;
`;
